import {TabState, TabStateDefaults} from 'Navigation';

export default class StorableRelevantItemsTabState extends TabState {
  override defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Relevant Items',
      closeable: false,
      preferenceKey: 'storable-relevant-items-tab',
    };
  }
}
